/**
 * Browser-safe spec loader for tool runners.
 * Uses pre-bundled specs so node:fs/node:path are never pulled into the client bundle.
 * Same API as specLoader.ts so it can be resolved in place via Vite alias.
 */

import type { RawToolSpec } from "../harmonizer/specLoader";
import { getBundledSpecs } from "../harmonizer/bundledSpecs";

const BUNDLED_PREFIX = "bundled:";

/** Map tool dir name (e.g. "rice-scoring") to identity.tool_name (e.g. "RICE") in bundled specs. */
const TOOL_DIR_TO_NAME: Record<string, string> = {
  "rice-scoring": "RICE",
  wsjf: "WSJF",
  "dot-voting": "DotVoting",
  "pairwise-ranking": "Pairwise Ranking",
  "moscow-method": "MOSCOW",
  "impact-effort-matrix": "IMPACT_EFFORT_MATRIX",
  "simple-weighted-scoring": "Simple Weighted Scoring",
  "pareto-analysis": "PARETO",
  "cost-of-delay": "CostOfDelay",
  "buy-a-feature": "Buy A Feature",
  "max-priorities-pyramid": "Max Priorities Pyramid",
  "stack-ranking": "Stack Ranking",
};

export function loadToolSpecFile(specPath: string): RawToolSpec {
  if (!specPath.startsWith(BUNDLED_PREFIX)) {
    throw new Error(
      `Browser loader only supports bundled specs (path must start with "${BUNDLED_PREFIX}"). Got: ${specPath}`
    );
  }
  const toolDirName = specPath.slice(BUNDLED_PREFIX.length);
  const toolName = TOOL_DIR_TO_NAME[toolDirName];
  if (!toolName) {
    throw new Error(`Unknown tool dir for bundled spec: ${toolDirName}`);
  }
  const specs = getBundledSpecs();
  const spec = specs.find((s) => s.identity?.tool_name === toolName);
  if (!spec) {
    throw new Error(
      `Bundled spec not found for tool "${toolName}" (dir: ${toolDirName}). Run build:tool-specs and rebuild.`
    );
  }
  return spec as RawToolSpec;
}

export function findToolSpecInDir(
  _dirPath: string,
  _toolName?: string
): string | null {
  return null;
}

export function getToolSpecPath(
  toolDirName: string,
  _rootDir?: string
): string {
  return BUNDLED_PREFIX + toolDirName;
}
